var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsultaRapidaERecomendacoes(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.5,8.4c0.6,1.5,0.6,3.2,0,4.7c-0.6,1.5-1.8,2.7-3.3,3.3c-0.8,0.3-1.5,0.5-2.3,0.5c-1.3,0-2.6-0.4-3.6-1.2 l-4.6,4.5c-0.2,0.2-0.4,0.2-0.6,0.2c-0.2,0-0.4-0.1-0.6-0.3c-0.3-0.3-0.3-0.9,0-1.2L9,14.5c-0.3-0.4-0.6-0.9-0.8-1.4 c-1-2.4-0.3-5.2,1.6-6.9c0.3-0.2,0.7-0.2,0.9,0.1c0.2,0.3,0.2,0.7-0.1,0.9C9,8.5,8.5,10.7,9.3,12.6c1,2.5,3.9,3.7,6.4,2.7 c1.2-0.5,2.1-1.4,2.6-2.6c0.5-1.2,0.5-2.5,0-3.7c-0.8-1.9-2.7-3.1-4.8-3c-0.3,0-0.6-0.2-0.7-0.6c0-0.3,0.2-0.6,0.6-0.7 C16.1,4.5,18.5,6,19.5,8.4 M10.3,12.3c0.1,0.3,0.2,0.5,0.4,0.7c0.1,0.2,0.3,0.3,0.5,0.3c0.1,0,0.2,0,0.4-0.1 c0.3-0.2,0.4-0.6,0.2-0.9c-0.1-0.2-0.2-0.3-0.3-0.5c-0.6-1.4,0.1-3,1.5-3.6c1.3-0.5,2.8,0,3.5,1.3c0.2,0.3,0.5,0.4,0.8,0.3 c0.3-0.2,0.4-0.5,0.3-0.8c-1-1.8-3.2-2.6-5.1-1.8C10.4,7.9,9.4,10.2,10.3,12.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultaRapidaERecomendacoes);
export default __webpack_public_path__ + "static/media/consulta_rapida_e_recomendacoes.c3462e69d7e47e22742d060050abecd3.svg";
export { ForwardRef as ReactComponent };